import { api } from "../../api/API";
import { Task } from "../../api/Tasks";
import { useSnackAction } from "../../misc/SnackAction";
import { PanelTaskTabs } from "./PanelTaskTabs";

// GoalTasks lists what the goal is being reached by, the tasks already ticked off
// included, and takes the next ones straight off the keyboard.
export function GoalTasks(props: {
    goalId: number;
    projectId: number;
    onOpenTask: (task: Task) => void;

    // onOpenCount reports how many of the goal's tasks are still open
    onOpenCount?: (count: number) => void;
}) {
    const add = useSnackAction(async (input: { title: string }) => {
        await api.tasks.upsert({ title: input.title, goal: props.goalId, project: props.projectId });
    }, { success: "Added" });

    // a task outlives the goal it was working towards, so taking it off the list
    // leaves it under the project the goal sits in
    const unassign = useSnackAction(async (input: { task: Task }) => {
        await api.tasks.upsert({
            ...input.task,
            goal: null,
        });
    }, { success: "Removed from goal" });

    return (
        <PanelTaskTabs
            scope={{ goal: props.goalId }}
            addPlaceholder="Add a task to this goal"
            removeLabel="Remove from goal"
            busy={unassign.loading}
            onAdd={title => add.callback({ title: title })}
            onOpen={props.onOpenTask}
            onRemove={task => unassign.callback({ task: task })}
            onPendingCount={props.onOpenCount}
        />
    );
}
